import styled from "styled-components"
import colors from "~constants/colors"
import { getInitials } from "~utils/user"

type Props = {
  name: string
}

const UserInitials = (props: Props) => {
  return (
    <Container>
      <span className="initials">{getInitials(props.name)}</span>
    </Container>
  )
}

const Container = styled.div`
  border-radius: 50%;
  background-color: ${colors.blue5};
  height: 42px;
  padding: 9px;
  width: 42px;

  > span.initials {
    display: block;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    color: ${colors.blue4};
  }
`

export default UserInitials
